import Common from "./common";

export default Common;
